import axios, {AxiosResponse} from "axios";
import {Branch} from "@/types/models";

export const getBranch = async (id: number) => {
    return await axios
        .get(route("api.branch.hierarchy", {id: id}))
        .then((response: AxiosResponse<Record<number, Branch>>) => {
            return response.data
        })
        .catch((error: Error) => {
            console.warn(`${route} call failed: ${error}`)
            throw error
        })
}
